<template>
    <the-section class="contact" id="contact">
        <template v-if="mode !== 'footer'">
            <line-footer class="decoration" />
            <contact-details :mode="mode" />
        </template>
        <line-section />
        <div class="jobs" id="jobs">
            <a class="title" href="#/jobs" @click="scrollTop()">
                Join&nbsp;<strong>the tribe</strong>
            </a>
        </div>
        <line-section />
        <contact-socials />
    </the-section>
</template>
<script>
import ContactDetails from "@/components/ContactDetails.vue";
import ContactSocials from "@/components/ContactSocials.vue";
import LineFooter from "@/components/LineFooter";
import LineSection from "@/components/LineSection";
import getters from "@/mixins/getters.mixin";
import TheSection from "@/components/TheSection";
import { clearScroll, scroll } from "@/services/scroll.animation";

export default {
    mixins: [getters],
    props: {
        mode: {
            type: String,
            default: "nice",
        },
    },
    components: {
        ContactDetails,
        ContactSocials,
        LineFooter,
        LineSection,
        TheSection,
    },
    computed: {
        section() {
            return this.getSection("homepage_hero");
        },
        colors() {
            return this.section.colors;
        },
    },
    mounted() {
        scroll("contact-section", this.$el, this.section.colors);
    },
    beforeDestroy() {
        clearScroll("contact-section");
    },
    methods: {
        scrollTop() {
            window.scroll({ top: 0 });
        },
    },
};
</script>

<style lang="sass" scoped>
@import ~include-media/dist/include-media
@import ~styles/base
@import ~styles/typography

.contact
    --section-padding: calc(var(--line-base) * 2)
    --link-padding: var(--line-base)

    display: flex
    flex-direction: column
    justify-content: center
    color: white

    +media('<small')
        text-align: center
        padding-top: var(--section-padding)
        padding-bottom: var(--section-padding)

    +media('>=small')
        --section-padding: calc(var(--line-base) * 2)

    .decoration
        +media('<small')
            margin-bottom: var(--section-padding)

    svg
        display: block
        margin-left: auto
        margin-right: auto
        stroke: currentColor
        max-width: 50%

        +media('>=small')
            max-width: 16.667%

    ::v-deep

        .column
            flex-basis: 33.333333%
            box-sizing: border-box

            +media('>=small')
                flex-basis: 50%

                &:first-child
                    text-align: right
                    padding-right: 4.166667%

                &:last-child
                    padding-left: 4.166667%

.title
    text-align: center

.jobs
    padding-top: var(--link-padding)
    padding-bottom: var(--link-padding)
    text-align: center
</style>
